var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M6.4585 6.45837L13.5418 13.5417M13.5418 6.45837L6.4585 13.5417","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }